module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/social/instagram-f0cfa30d48f79bb3d8c99ebf43dea781.svg";